import React from 'react';
import {HashRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import {AuthProvider} from './contexts/AuthContext';
import {AdminProvider} from './contexts/AdminContext';

// Customer App Components
import LandingPage from './components/customer/LandingPage';
import AuthPage from './components/customer/AuthPage';
import Dashboard from './components/customer/Dashboard';
import PricingPage from './components/customer/PricingPage';
import MonitorsPage from './components/customer/MonitorsPage';
import MediaLibrary from './components/customer/MediaLibrary';
import SyncGroupManager from './components/customer/SyncGroupManager';
import ProtectedRoute from './components/customer/ProtectedRoute';

// Admin App Components
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUsers from './components/admin/AdminUsers';
import AdminSupport from './components/admin/AdminSupport';
import AdminAnalytics from './components/admin/AdminAnalytics';
import AdminProtectedRoute from './components/admin/AdminProtectedRoute';

// Android TV App
import AndroidTVApp from './components/androidtv/AndroidTVApp';
import TVSetup from './components/androidtv/TVSetup';
import TVPlayer from './components/androidtv/TVPlayer';
import SyncSetup from './components/androidtv/SyncSetup';
import MultiScreenSync from './components/androidtv/MultiScreenSync';

import './index.css';

function App() {
  const currentPath = window.location.hash;

  // Route to appropriate app based on path
  if (currentPath.startsWith('#/admin')) {
    return (
      <AdminProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>} />
              <Route path="/admin/users" element={<AdminProtectedRoute>
                <AdminUsers />
              </AdminProtectedRoute>} />
              <Route path="/admin/support" element={<AdminProtectedRoute>
                <AdminSupport />
              </AdminProtectedRoute>} />
              <Route path="/admin/analytics" element={<AdminProtectedRoute>
                <AdminAnalytics />
              </AdminProtectedRoute>} />
              <Route path="/admin/*" element={<Navigate to="/admin/login" replace />} />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </Router>
      </AdminProvider>
    );
  }

  if (currentPath.startsWith('#/tv')) {
    return (
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900">
          <Routes>
            <Route path="/tv" element={<AndroidTVApp />} />
            <Route path="/tv/setup" element={<TVSetup />} />
            <Route path="/tv/player/:monitorId" element={<TVPlayer />} />
            <Route path="/tv/sync-setup" element={<SyncSetup />} />
            <Route path="/tv/sync/:groupId/:screenIndex" element={<MultiScreenSync />} />
            <Route path="/tv/*" element={<Navigate to="/tv" replace />} />
          </Routes>
        </div>
      </Router>
    );
  }

  // Default to customer app
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-violet-900 via-purple-900 to-fuchsia-900">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/dashboard" element={<ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>} />
            <Route path="/monitors" element={<ProtectedRoute>
              <MonitorsPage />
            </ProtectedRoute>} />
            <Route path="/media" element={<ProtectedRoute>
              <MediaLibrary />
            </ProtectedRoute>} />
            <Route path="/sync-groups" element={<ProtectedRoute>
              <SyncGroupManager />
            </ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;